/**
 * A list of variables and simple functions for across our files
 */

export const breakpoints = {
    portraitPhone: 479,
    landscapePhone : 767,
    portraitTablet: 1023,
    landscapeTablet: 1119,
    desktop: 1500,
    oversized: 1700
};

export function getScreenSize() {
    return window.innerWidth;
}